import React, { useEffect, useContext, useState } from "react";
import CalendarDatePicker from "../../components/_default/Calendar";
import Appointment from "../../components/_default/Calendar/appointment";
import NavButton from "../../components/_default/NavButton";
import Profile from "../../components/_dashboard/profile";
import Graph from "../../components/_dashboard/graph";
import UserContext from "../../services/context/userContext";
import {
  getClients,
  getWorkoutsCoach,
  getCLientByName,
  getMealplanFromClient,
  getWorkoutFromClient,
  getAllMealplansForUser,
  getCoachesCalendarItemsDates,
  getCoachesTaskItem,
  geSortedChats,
  geClientsChats,
  getCoachesClientsItem,
} from "../../services/firebase/firestore/getData";
import DropDown from "../../components/_default/DropDown";
import { Link } from "react-router-dom";
import "./Dashboard.scss";
import { doSignOut } from "../../services/firebase/auth";
import Icon from "../../components/_default/Icon";
import CalendarItem from "../../components/_default/Calendar";
import TodoList from "../../components/_clients/Calendar/TodoList";
import SearchPage from "../../components/_default/SearchPage";
import ExerciseList from "../../components/_exercises/ExerciseList";
import ClientDetailPopup from "../../components/_default/Popup/ClientDetailPopup";
import Loading from "../../components/_default/Loading";
import moment from "moment";
import ChatList from "../../components/_clients/ChatList";
import Popup from "../../components/_default/Popup";
import { deleteClient } from "../../services/firebase/firestore/deleteData";

function DashboardHome({ t }) {
  const btnStyle = {
    width: "352px",
    float: "left",
    backgroundColor: "rgb(255,196,21)",
    borderRadius:"5px",
  };
  const [clientCount, setClientCount] = useState(false);
  const [workoutCount, setWorkoutCount] = useState(false);
  //   const [filter, setFilter] = useState(false);
  const [filterName, setFilterName] = useState(false);
  const [client_name, setCLientName] = useState(false);
  const [clients, setClients] = useState(false);
  const user = useContext(UserContext);
  let [clientInfo, setClientInfo] = useState([]);

  const [selectedClientId, setSelectedClientId] = useState(false);
  const [totalMeals, setTotalMeals] = useState(0);
  const [totalCalories, setTotalCalories] = useState(0);
  const [totalCaloriesDone, setTotalCaloriesDone] = useState(0);

  const [totalExercises, setTotalExercises] = useState(0);
  const [exercisesDone, setExercisesDone] = useState(0);
  const [totalExerciseTime, setTotalExerciseTime] = useState(0);
  let url = new URL(window.location.href);
  const [searchValue, setSearchValue] = useState("");

  const filters = ["Sort by name", "Sort by date"];
  const [filter, setFilter] = useState("Sort by name");
  const filterTypes = ["Ascending", "Descending"];
  const [filterType, setFilterType] = useState("Ascending");
  let [clientData, setClientData] = useState(false);
  let [clientDetail, setClientDetail] = useState({});
  let [loading, setLoading] = useState(true);
  let [desc, SetDesc] = useState(false);
  let [timeStam, setTimeStamp] = useState();
  let [mealPlanDates, setMealPlanDates] = useState([]);
  const [deleteClientPopUp,setDeleteClientPopup]=useState(false)
  const [sortClientByChat,setSortClientByChat]=useState([])
  const [opnChat,setOpnChat]=useState(false)
  let [msgSent,setMsgSent]=useState(false)
  let [itemAdded,setItemAdded]=useState(false)
  let [itemDeleted,setItemDeleted]=useState(false)
  const [loadingChat,setLoadingChat]=useState(false)
  // const [delete]
  //   useEffect(() => {
  //     sorter({ ...exercises });
  //   }, [filter, filterType])

  function handleLogout() {
    doSignOut();
  }

  function sortClient(a, b) {
    // debugger
    // if (a.first_name + " " + a.last_name < b.first_name + " " + b.last_name) {
    //     return -1;
    // }
    // if (a.first_name + " " + a.last_name > b.first_name + " " + b.last_name) {
    //     return 1;
    // }
    // return 0;

    const name1 = a.first_name + " " + a.last_name;
    const name2 = b.first_name + " " + b.last_name;

    let comparison = 0;

    if (name1 > name2) {
      comparison = 1;
    }
    if (name1 < name2) {
      comparison = -1;
    }
    return comparison;
  }
  function sortClientDesc(a, b) {
    const name1 = a.first_name + " " + a.last_name;
    const name2 = b.first_name + " " + b.last_name;

    let comparison = 0;

    if (name1 < name2) {
      comparison = 1;
    }
    if (name1 > name2) {
      comparison = -1;
    }
    return comparison;
  }
  function sortClientByDOB(a, b) {
    // debugger
    if (a.date_of_birth < b.date_of_birth) {
      return -1;
    }
    if (a.date_of_birth > b.date_of_birth) {
      return 1;
    }
    return 0;
  }
  const handleSortClient = (e) => {
    // console.log("sort client handle", e)
    setFilter(e);
  };

  useEffect(() => {
    // debugger
    if (searchValue) {
      const results = clientInfo.filter((client) => {
        if (searchValue === "") return clientInfo;
        return (client.first_name + " " + client.last_name)
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setClientInfo(results);
      // console.log("filter client info", results, clientInfo)
    } else if (filter === "Sort by date" && desc) {
      getClients(user.id, (result) => {
        if (result) {
          setLoading(false);

          let res = result.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
            return (
              b.date_of_birth?.toDate().getFullYear() -
              a.date_of_birth?.toDate().getFullYear()
            );
            // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
          });
          // console.log("result", result[0].date_of_birth.toDate().getFullYear());
          setClientInfo(res);
          let clientNames = [];
          let clients = [];
          result &&
            result.forEach((element) => {
              clientNames.push(element.first_name + " " + element.last_name);
              clients.push({
                name: element.first_name + " " + element.last_name,
                id: element.id,
              });
            });
          setFilterName(clientNames);
          setCLientName(result[0].first_name + " " + result[0].last_name);
          setClients(clients);
        }
      });
    } else if (filter == "Sort by date") {
      getClients(user.id, (result) => {
        if (result) {
          setLoading(false);

          let res = result.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
            return (
              a.date_of_birth?.toDate().getFullYear() -
              b.date_of_birth?.toDate().getFullYear()
            );
            // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
          });
          // console.log("result", result[0].date_of_birth.toDate().getFullYear());
          setClientInfo(res);
          let clientNames = [];
          let clients = [];
          result &&
            result.forEach((element) => {
              clientNames.push(element.first_name + " " + element.last_name);
              clients.push({
                name: element.first_name + " " + element.last_name,
                id: element.id,
              });
            });
          setFilterName(clientNames);
          setCLientName(result[0].first_name + " " + result[0].last_name);
          setClients(clients);
        }
      });
    } else if (filter) {
      // debugger
      if (!desc) {
        getClients(user.id, (result) => {
          setClientCount(result.length);
        });

        getClients(user.id, (result) => {
          if (result) {
            setLoading(false);
            result = result.sort(sortClient);

            setClientInfo(result);
            let clientNames = [];
            let clients = [];
            result &&
              result.forEach((element) => {
                clientNames.push(element.first_name + " " + element.last_name);
                clients.push({
                  name: element.first_name + " " + element.last_name,
                  id: element.id,
                });
              });
            setFilterName(clientNames);
            setCLientName(result[0].first_name + " " + result[0].last_name);
            setClients(clients);
          }
        });
      } else {
        getClients(user.id, (result) => {
          setClientCount(result.length);
        });

        getClients(user.id, (result) => {
          if (result) {
            
            setLoading(false);
            result = result.sort(sortClientDesc);

            setClientInfo(result);
            let clientNames = [];
            let clients = [];
            result &&
              result.forEach((element) => {
                clientNames.push(element.first_name + " " + element.last_name);
                clients.push({
                  name: element.first_name + " " + element.last_name,
                  id: element.id,
                });
              });
            setFilterName(clientNames);
            setCLientName(result[0].first_name + " " + result[0].last_name);
            setClients(clients);
          }
        });
      }
    }
  }, [searchValue, filter, desc,loading]);


  // console.log("clientsss",clientInfo)
  // useEffect(() => {
  //     if (searchValue) {
  //         const results = clientInfo.filter(client => {
  //             if (searchValue === "") return clientInfo
  //             return (client.first_name + " " + client.last_name).toLowerCase().includes(searchValue.toLowerCase())
  //         })
  //         setClientInfo(results)
  //         console.log("filter client info", results, clientInfo)
  //     }
  //     else if (filter) {
  //         debugger

  //         if (filter == "Sort by category") {
  //             debugger
  //             console.log("sorted", clientInfo.sort(sortClient))
  //             clientInfo = clientInfo.sort(sortClient)
  //             setClientInfo(clientInfo)
  //         }else if(filter=="Sort by date"){
  //             debugger
  //             let res= clientInfo.sort(function(a,b){
  //                 // Turn your strings into dates, and then subtract them
  //                 // to get a value that is either negative, positive, or zero.
  //                 return a.date_of_birth?.toDate().getDate()/a.date_of_birth?.toDate().getMonth() + 1/a.date_of_birth?.toDate().getFullYear()- b.date_of_birth?.toDate().getDate()/b.date_of_birth?.toDate().getMonth() + 1/b.date_of_birth?.toDate().getFullYear() ;
  //               });
  //             //   let res=clientInfo.sort(function(a,b){return a.date_of_birth.getTime() - b.date_of_birth.getTime()});
  //             setClientInfo(res)
  //             console.log("sorted date", res)
  //             // clientInfo = clientInfo.sort(sortClientByDOB)
  //         }
  //     }
  //     console.log("cleints", clientInfo)
  // }, [searchValue, filter])

  useEffect(() => {
    getWorkoutsCoach(user.id, (result) => {
      setWorkoutCount(result.length);
    });
  });

  var a = new Date();
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var day = a.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  var time = year + "-" + month + "-" + day;
  var currentTime = year + "-" + month + "-" + day;
  var date = day + "/" + month + "/" + year;
  let longMonth = a.toLocaleString("en-us", { month: "long" });
  const [fullTime, setFullTime] = useState(day + " " + longMonth + " " + year);
  let shortMonth = a.toLocaleString("en-us", { month: "short" });
  const [shortFullTime, setShortFullTime] = useState(
    day + " " + shortMonth + " " + year
  );
  const [Time, setTime] = useState(time);

  function handleCalendarChange(newSelectedDate) {
    // console.log("selected date", newSelectedDate);
    var timestamp = new Date(Date.parse(newSelectedDate));
    setTimeStamp(timestamp);
    // console.log("time stamp", timestamp)
    var year = timestamp.getFullYear();
    var month = timestamp.getMonth() + 1;
    var day = timestamp.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    time = year + "-" + month + "-" + day;
    date = day + "/" + month + "/" + year;
    longMonth = a.toLocaleString("en-us", { month: "long" });
    const __date = new Date(year, month - 1, day);
    setFullTime(
      day + " " + __date.toLocaleString("en-us", { month: "long" }) + " " + year
    );
    shortMonth = a.toLocaleString("en-us", { month: "short" });
    setShortFullTime(day + " " + shortMonth + " " + year);
    setTime(time);
  }

  function handleClient(result) {
    // let _filtered_by_category = { ...categories };
    // let _exercises = { ...exercises };
    // _exercises.aurum = result.aurum.items;
    // _exercises.coach = result.coach.items;
    // setInitialExercises(_exercises);
    // setExercises(_exercises);
    // if (checked.length > 0) {
    //   handleCategories(checked, _exercises, from);
    // } else {
    //   setExercises(_exercises);
    // }
    // Object.values(result).map((item) => {
    //   let filtered_by_category = [];
    //   item.items && item.items.map((item) => {
    //       let _index = filtered_by_category.findIndex((e) => e.category === item.category);
    //       if (_index !== -1) {
    //         filtered_by_category[_index].count += 1;
    //       } else {
    //         filtered_by_category.push({ category: item.category, count: 1 });
    //       }
    //       return filtered_by_category;
    //     });

    //     // sorter(_exercises);

    // //   _initial_categories.map((item) => {
    // //     let _index = filtered_by_category.findIndex((e) => e.category === item);
    // //     if (_index === -1) {
    // //       filtered_by_category.push({ category: item, count: 0 });
    // //     }
    // //   });

    //   return (_filtered_by_category[item.type] = filtered_by_category);
    // });
    let filtered_by_category = [];
    result.map((item) => {
      let _index = filtered_by_category.findIndex(
        (e) => e.category === item.category
      );
      if (_index !== -1) {
        filtered_by_category[_index].count += 1;
      } else {
        filtered_by_category.push({ category: item.category, count: 1 });
      }
      return filtered_by_category;
    });
    // setCategories(_filtered_by_category);

    // setShowPopup(false);
  }

  useEffect(() => {
    getCoachesCalendarItemsDates(user.id, (res) => {
      // console.log("get coach calendaritems dates", res)
      if (res) {
        res.map((data) => {
          
          // console.log("Datessss",data)
          // let myDate = data.id;
          let myDate = data.date
           
          getCoachesTaskItem(user.id,myDate,res=>{
            // debugger
            if(res.length>0){
              myDate = myDate?.split("-");
          var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
          // console.log("date prop", newDate);
          // console.log("item exists",newDate.getTime());
          mealPlanDates.push(newDate.getTime());
          setMealPlanDates(mealPlanDates)
            }
          })
          getCoachesClientsItem(user.id,myDate,res=>{
            // debugger
            if(res.length>0){
              myDate = myDate.split("-");
          var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
          // console.log("date prop", newDate);
          // console.log("item exists",newDate.getTime());
          mealPlanDates.push(newDate.getTime());
          setMealPlanDates(mealPlanDates)
            }
          })
          // myDate = myDate.split("-");
          // var newDate = new Date(myDate[0], myDate[1] - 1, myDate[2]);
          // // console.log("date prop", newDate);
          // mealPlanDates.push(newDate.getTime());
          // // setMealPlanDates([...mealPlanDates,data.date])
        });
      } else {
        // console.log("not any coachcalendar item exists");
      }

      // console.log("meal plan dates", mealPlanDates)
    });
  }, [mealPlanDates,itemAdded,itemDeleted]);

  useEffect(() => {
    // debugger
    var userId;
    if (client_name && clients) {
      // debugger
      clients.forEach((element) => {
        if (element.name == client_name) {
          userId = element.id;
          setSelectedClientId(element.id);
        }
      });
      //meals
      getMealplanFromClient(userId, Time, (result) => {
        // console.log(Time);
        // console.log(result);
        // console.log("user id", userId);
        if (result) {
          setTotalMeals(result.plan.length);
          setTotalCalories(result.totalCaloriesAllowed);
          var caloriesDone = 0;
          result.plan.map((item) => {
            item.food.map((item) => {
              if (item.eaten) {
                caloriesDone = parseInt(caloriesDone) + parseInt(item.calories);
              }
            });
          });
          setTotalCaloriesDone(caloriesDone);
        } else {
          setTotalMeals(0);
          setTotalCalories(0);
          setTotalCaloriesDone(0);
        }
      });
      //workouts
      getWorkoutFromClient(userId, Time, (result) => {
        if (result) {
          // console.log(result);
          let totalExerciseAmount = 0;
          let totalExercisesDone = 0;
          let totalSecondsExercises = 0;

          result.supersets.map((item) => {
            item.exercises.map((item) => {
              totalExerciseAmount++;
              if (item.completed) {
                totalExercisesDone++;
              }

              // totalSecondsExercises = parseInt(totalSecondsExercises) + (((parseInt(item.up) + parseInt(item.up_pause) + parseInt(item.down_pause) + parseInt(item.down) + parseInt(item.rest_time_in_minutes))* parseInt(item.reps))* parseInt(item.sets))
            });
          });

          // console.log(totalSecondsExercises);

          setTotalExercises(totalExerciseAmount);
          setExercisesDone(totalExercisesDone);
          // setTotalExerciseTime(parseInt(totalSecondsExercises/60).toFixed(0));
        } else {
          setTotalExercises(0);
          setExercisesDone(0);
          setTotalExerciseTime(0);
        }
      });
    }
  }, [client_name, Time, clients]);

  function onClick(item) {
    window.location.href = item + "/" + selectedClientId;
  }

  function setFilterParam(e) {
    let search_params = url.searchParams;
    search_params.set("filter", e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }

  function setFilterTypeParam(e) {
    let search_params = url.searchParams;
    search_params.set("filterType", e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
  }
  function sorter(c) {
    if (clientInfo) {
      clientInfo.sort((a, b) => {
        let firstCheck =
          filter === "Sort by category"
            ? a.first_name + " " + a.last_name
            : a.name;
        let secondCheck = filter === "Sort by category" ? b.category : b.name;
        if (firstCheck > secondCheck) {
          return filterType == "Ascending" ? 1 : -1;
        }
        if (secondCheck > firstCheck) {
          return filterType == "Ascending" ? -1 : 1;
        }
        return 0;
      });
    }

    setClientInfo(clientInfo);
  }

  function searchClientList(e) {
    // console.log("client e", e)
    setSearchValue(e);
    let search_params = url.searchParams;
    search_params.set("search", e);
    url.search = search_params.toString();
    let new_url = url.toString();
    window.history.replaceState(null, null, new_url);
    // let filterClient=clientInfo.filter((client)=>client.first_name+" "+client.last_name==e)

    // if(clientInfo){
    //   handleClient(clientInfo);
    //     // let finalResult = { aurum: { items: [], type: "aurum" }, coach: { items: [], type: "coach" } };
    //     let finalResult = [];
    //     if(clientInfo) {
    //       clientInfo.map((item) => {
    //         if((item.first_name+" "+item.last_name).toLowerCase().includes(e.toLowerCase())) {
    //           finalResult.push(item);
    //         }
    //       })
    //     }

    //     if(e === "") {
    //         handleClient(clientInfo);
    //     }else {
    //         handleClient(finalResult);
    //     }
    // }
    // let _checked_categories = [...checked];

    // if(_checked_categories && _checked_categories.length > 0){
    //   handleCategories(_checked_categories, initialExercises, from);
    // }
  }
  const handleSelectClient = () => {
    // debugger
    setClientData(true);
    getClients(user.id, (result) => {
      if (result) {
        // debugger
        result = result.sort(sortClient);
       
        setClientInfo(result);
        let clientNames = [];
        let clients = [];
        result &&
          result.forEach((element) => {
            clientNames.push(element.first_name + " " + element.last_name);
            clients.push({
              name: element.first_name + " " + element.last_name,
              id: element.id,
            });
          });
        setFilterName(clientNames);
        setCLientName(result[0].first_name + " " + result[0].last_name);
        setClients(clients);
      }
    });
  };
  let [client_id,setClientId]=useState("")

  const gotoClient=(clientId)=>{
    window.location.href = '/clients/' +clientId ;
  }
  let removeClient = () => {
		// debugger
		// console.log("clientssss", clients)
		// setDeleteModal(false)
    // setDeleteClientPopup(true)
		// console.log("del id", selected_client.id)

    setLoading(true)
		deleteClient(client_id, res => {
			// console.log("dele res", res,client_id)
      if (res) {
				// window.location.href = "/clients/" + clients[clients.length - 2].id
        setDeleteClientPopup(false)
        setLoading(false)
			} else {
				// window.location.href = "/clients/" + clients[clients.length - 1].id
        setDeleteClientPopup(false)
        setLoading(false)
			}
		})
	}
  setInterval(()=>{
    setLoadingChat(true)
  },1000)
  useEffect(()=>{
    // getCoachesTaskItem(user.id,"2023-02-06" ,res=>{
    //   console.log('tasks',res)
    // })
    let lastestOneDate

    let most_recent_chats=[]
    let allMostRecentDates=[]
    // setInterval(()=>{

    // },1000)
    getClients(user.id,totalClients=>{
      totalClients.map((client,i)=>{
        geClientsChats(client.id,result=>{
          // let filterArray
           console.log("result",Array.isArray(result))
          let filterArray=Array.isArray(result)&&result.filter(data=>data?.created)
            // console.log("msg chats",client.first_name, filterArray ,result)

            const chatGreetingMsg=filterArray.filter((data)=>data[filterArray.length-1]?.sender==data[filterArray.length-2]?.sender)
            // console.log("IB msg", chatGreetingMsg)
            if(filterArray.length>0){
              let sortedOneClientChat=filterArray.sort(function(a,b){return b.created.toDate().getTime()-a.created.toDate().getTime()})
              allMostRecentDates.push({mostRecentChatTime:sortedOneClientChat[0].created,ack:sortedOneClientChat[0].read,senderID:sortedOneClientChat[0].sender, ...client})
              // allMostRecentDates=[...allMostRecentDates,{mostRecentChatTime:sortedOneClientChat[0].created,ack:sortedOneClientChat[0].read,senderID:sortedOneClientChat[0].sender, ...client}]
              allMostRecentDates.sort(function(a,b){return b.mostRecentChatTime.toDate().getTime()-a.mostRecentChatTime.toDate().getTime()})
              let arr=[...allMostRecentDates]
              setSortClientByChat(arr)
              // let chatGreetingMsg=filterArray.sort(function(a,b){return a.created.toDate().getTime()-b.created.toDate().getTime()})
              // console.log("msg chat",chatGreetingMsg ,arr)
              // if(chatGreetingMsg[0]?.sender==chatGreetingMsg[1]?.sender){
              //   console.log("greeting msg",chatGreetingMsg[0]?.message)
              //   chatGreetingMsg.splice(0,1 ,"okiiii faisal")
              // }
              
            }
            else{
              setSortClientByChat(totalClients)
            }
            
          
            
          })
        })
       
      })
      // debugger
    
  },[msgSent,opnChat,loadingChat])
  return (
    <>
      
        <div className="c-page-wrapper c-page-dashboard">
            
          <Profile
            user={user}
            clientCount={clientCount}
            workoutCount={workoutCount}
          ></Profile>
          <div
            className="c-page-wrapper"
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "20px",
            }}
          >
            <div
              className="c-page-side c-page-side-offset"
              style={{ minHeight: "unset", height: "unset" }}
            >
              <div
                className="c-dashboard-calender-wrapper"
                style={{ display: "flex" }}
              >
                <div style={{ marginLeft: "8px" }}>
                  <CalendarItem
                    time={mealPlanDates}
                    onCalendarChange={handleCalendarChange}
                  />
                </div>
                {
                  opnChat?"":
                  <div className="todo-background">
                  <TodoList
                  itemAdded={itemAdded}
                  setItemAdded={setItemAdded}
                  itemDeleted={itemDeleted}
                  setItemDeleted={setItemDeleted}
                    Time={Time}
                    style={btnStyle}
                    fulltime={fullTime}
                    shortFulltime={shortFullTime}
                  />
                </div>
                }
                
                <div className="todo-background" >
                    <ChatList 
                    msgSent={msgSent}
                    setMsgSent={setMsgSent}
                    clientsList={sortClientByChat}
                    opnChat={opnChat}
                    setOpnChat={setOpnChat}
                    />
                </div>

                {/*<CalendarDatePicker onCalendarChange={handleCalendarChange}></CalendarDatePicker>*/}
              </div>
              {/*<div className="c-appointment-list">
            <h2 className="c-appointmet-title">{fullTime}</h2>
            <Appointment user={user} time={Time} currentTime={currentTime}></Appointment>    
            <NavButton text="View Agenda" icon="chevron-right" coloricon="#443712" size={25} onClick={() => onClick('clients')}/>
          </div>*/}
            </div>

            <div
              className="c-exercise-finder"
              style={{
                marginTop: "30px",
                marginLeft: "15px",
              }}
            >
              <SearchPage
                placeholder="Search client"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
              <div className="c-dropdown-holder">
                <DropDown
                  options={filters}
                  value={filter}
                  onChange={handleSortClient}
                />
                <DropDown
                  options={filterTypes}
                  value={filterType}
                  onChange={() => {
                    SetDesc(!desc);
                    setFilterType(
                      filterType == "Ascending" ? "Descending" : "Ascending"
                    );
                  }}
                />
              </div>
            </div>
            {
              loading?
              <div>
                <Loading />
              </div>:
              <div style={{ marginLeft: "15px" }}>
              {/* <ExerciseList  clientPopUp={true} clients={clientInfo} activeClient={true} /> */}

              <div className="c-exercise-list">
                <div
                  className="c-exercise-list-item-homepage"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "unset",
                  }}
                >
                  {clientInfo.map((client) => {
                    return (
                      // <Link to={`/clients/${client.id}`} style={{textDecoration:"none",color:"black"}}>
                      <div style={{display:"flex"}}>
                      <div
                        className="c-exercise-list-item-data-homepage"
                        key={client.id}
                        // onClick={handleSelectClient}
                        
                      >
                        {client.image ? (
                          <div
                            className="c-exercise-image-homepage"
                            style={{
                              backgroundImage: `url('${client.image}')`,
                            }}
                          />
                        ) : (
                          <div
                            className="c-exercise-image-homepage"
                            style={{ backgroundColor: "unset" }}
                           
                          >
                            {" "}
                            <Icon icon="users" />
                          </div>
                        )}
                        <div
                          className="c-exercise-text-homepage"
                          style={{ display: "contents" }}
                          onClick={()=>gotoClient(client.id)}
                        >
                          <h3
                            className="client-name"
                            style={{ width: "100px" }}
                          >
                            {client.first_name + " " + client.last_name}
                          </h3>
                          <p
                            className="client-p-tag"
                            style={{ width: "285px" }}
                          >
                            {client.email}
                          </p>
                          <p className="client-p-tag">
                            {client.date_of_birth?.toDate().getDate()}/
                            {client.date_of_birth?.toDate().getMonth() + 1}/
                            {client.date_of_birth?.toDate().getFullYear()}
                          </p>
                          <p className="client-p-tag">
                            {client.gender ? client.gender : "Not mentioned"}
                          </p>
                          <div
                            className="client-measurements"
                            style={{ display: "flex", width: "170px" }}
                          >
                            <span style={{ fontSize: "11px", fontWeight: 600 }}>
                              {client.measurements
                                ? client.measurements.weight + " " + "kg"
                                : "----"}
                            </span>
                            <span style={{ fontSize: "11px", fontWeight: 600 }}>
                              {client.measurements ? (
                                client.measurements.length + " " + "cm"
                              ) : (
                                <span
                                  style={{
                                    fontWeight: "700",
                                    fontSize: "13px",
                                  }}
                                >
                                  Not added
                                </span>
                              )}
                            </span>
                          </div>
                         
                        </div>
                        <button
                            onClick={() => {
                              setDeleteClientPopup(true)
                              // removeClient(client.id)
                              setClientId(client.id)
                              
                            }}
                            style={{cursor:"pointer"}}
                          >
                            <Icon size={20} height={20} icon="trash" />
                          </button>
                      </div>
                     
                      {/* // </Link> */}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            }
            
          </div>
          <div className="c-log-out" onClick={() => handleLogout()}>
            <Icon icon="log-out" size={20} stroke="#fff" />
          </div>
          {clientData && (
            <ClientDetailPopup
              onCancel={() => setClientData(false)}
              deletePopup={true}
              client_detail={clientDetail}
              time={time}
            />
          )}
           {
            deleteClientPopUp&&
            <Popup 
            title={"Delete Client"}
            button="Delete"
            deletePopup={true}
            description={"Are you sure you want to delete this Client? This can not be undone."}
            // onAction={removeClient}
            onCancel={() => {
              setDeleteClientPopup(false);
            }}
            onAction={removeClient}
            />
          }
        </div>
      
    </>
  );
}

export default DashboardHome;
